import Cookies from 'js-cookie'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    theme: 'default',
    livenewsChannels: Cookies.get('livenewsChannels') || '[]',
    visitedViews: [],
    bmsUrl: null
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    ADD_VISITED_VIEWS: (state, view) => {
      if (state.visitedViews.some(v => v.path === view.path)) return
      if (state.visitedViews.length > 0) {
        const first = state.visitedViews.shift()
        state.visitedViews.unshift({ name: view.name, path: view.path })
        state.visitedViews.unshift(first)
      } else {
        state.visitedViews.push({ name: view.name, path: view.path })
      }
    },
    DEL_VISITED_VIEWS: (state, view) => {
      let index = -1
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          index = i
          break
        }
      }
      if (index > -1) {
        state.visitedViews.splice(index, 1)
      }
    },
      DEL_OTHERS_VIEWS: (state, view) => {
          for (const [i, v] of state.visitedViews.entries()) {
              if (v.path === view.path) {
                  state.visitedViews = state.visitedViews.slice(i, i + 1)
                  break
              }
          }
      },
      DEL_ALL_VIEWS: (state) => {
        state.visitedViews =[]
      },
    jumpCon(state, path) {
      state.conUrl = path
    }
  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    addVisitedViews: ({ commit }, view) => {
      commit('ADD_VISITED_VIEWS', view)
    },
    delVisitedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    initViews({ commit, getters }, to) {
      commit('ADD_VISITED_VIEWS', { name: '首页', path: '/' })
      if (to.path !== '/' && to.path !== '/dashboard') {
        let pathName = null
        getters.routers.forEach(L1 => {
          if (to.path.indexOf(L1.path) > -1) {
            if (L1.children && L1.children.length > 0) {
              L1.children.forEach(L2 => {
                if (to.path.indexOf(L2.path) > -1) {
                  const pathArr = to.path.split('/')
                  if (pathArr[pathArr.length - 1] === L2.path) {
                    pathName = L2.name
                  }
                }
              })
            } else {
              pathName = L1.name
            }
          }
        })
        commit('ADD_VISITED_VIEWS', { path: to.path, name: pathName })
      }
    },
    checkClose({ state }, to) {
      return new Promise(resolve => {
        let isClose = true
        state.visitedViews.forEach(_ => {
          if (_.path === to.path) {
            isClose = false
          }
        })
        resolve(isClose)
      })
    },
      delAllViews({ commit, state }) {
          return new Promise((resolve) => {
              commit('DEL_ALL_VIEWS')
              resolve([...state.visitedViews])
          })
      },
      delOthersViews({ commit, state }, view) {
          return new Promise((resolve) => {
              commit('DEL_OTHERS_VIEWS', view)
              resolve([...state.visitedViews])
          })
      },
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js